import type {
  OnFarmImplantQueueEditableField,
  OnFarmImplantQueueFieldValue,
} from '@/services/on-farm-implant';

import { IMPLANT_QUEUE_SELECT_BLANK } from './columnDefs';

const NUMERIC_EDIT_FIELDS: ReadonlySet<OnFarmImplantQueueEditableField> =
  new Set(['quality', 'distance', 'implantType', 'clSide', 'dairyCompId']);

export const normalizeQueueCellValue = (
  field: OnFarmImplantQueueEditableField,
  value: unknown,
): OnFarmImplantQueueFieldValue => {
  if (value === null || value === undefined) return null;
  if (field === 'implantDate') {
    const date = String(value).trim().slice(0, 10);
    return date === '' ? null : date;
  }
  if (NUMERIC_EDIT_FIELDS.has(field)) {
    if (value === IMPLANT_QUEUE_SELECT_BLANK) return null;
    const numeric = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(numeric) ? numeric : null;
  }
  const text = String(value).trim();
  return text === '' ? null : text;
};
